import React from 'react'
import { Autocomplete, TextField, Checkbox, Chip, ListItemText } from '@mui/material'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import { CourierSelectorBox, SelectAllOption, SelectAllText } from './styled'

const icon = <CheckBoxOutlineBlankIcon fontSize='small' />
const checkedIcon = <CheckBoxIcon fontSize='small' />

const CourierSelector = ({
  options = [],
  value = [],
  onChange,
  label = 'Select Fallback Couriers',
  placeholder = 'Search and select couriers...',
  required = false,
}) => {
  const allSelected = value.length === options.length && options.length > 0
  const someSelected = value.length > 0 && value.length < options.length

  const handleChange = (event, newValue) => {
    const hasSelectAll = newValue.includes('__SELECT_ALL__')

    if (hasSelectAll) {
      if (allSelected) {
        onChange(event, [])
      } else {
        onChange(event, [...options])
      }
    } else {
      const filteredValue = newValue.filter((item) => item !== '__SELECT_ALL__')
      onChange(event, filteredValue)
    }
  }

  return (
    <CourierSelectorBox>
      <Autocomplete
        multiple
        options={options}
        value={value}
        onChange={handleChange}
        disableCloseOnSelect
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              color='primary'
              label={option}
              size='small'
              {...getTagProps({ index })}
              key={option}
            />
          ))
        }
        renderOption={(props, option, { selected }) => {
          if (option === '__SELECT_ALL__') {
            return (
              <SelectAllOption
                {...props}
                key='select-all'
                component='li'
              >
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  checked={allSelected}
                  indeterminate={someSelected}
                  sx={{ mr: 1 }}
                />
                <ListItemText
                  primary={
                    <SelectAllText variant='body2'>
                      {allSelected ? 'Deselect All' : 'Select All'}
                    </SelectAllText>
                  }
                />
              </SelectAllOption>
            )
          }

          return (
            <li {...props} key={option}>
              <Checkbox icon={icon} checkedIcon={checkedIcon} checked={selected} sx={{ mr: 1 }} />
              <ListItemText primary={option} />
            </li>
          )
        }}
        getOptionLabel={(option) => {
          if (option === '__SELECT_ALL__') {
            return ''
          }
          return option
        }}
        filterOptions={(options, params) => {
          const filtered = options.filter((option) =>
            option.toLowerCase().includes(params.inputValue.toLowerCase())
          )
          return filtered.length > 0 ? ['__SELECT_ALL__', ...filtered] : filtered
        }}
        isOptionEqualToValue={(option, value) => option === value}
        renderInput={(params) => (
          <TextField {...params} required={required} label={label} placeholder={placeholder} size='small' />
        )}
      />
    </CourierSelectorBox>
  )
}

export default CourierSelector
